import { Card, CardBody, Col } from "reactstrap";
import { MarginTitle } from "../../../../Constants/Constants";
import { MarginSubTitle, PaddingList } from "../../../../Data/UiKits/HelperClasses";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Margin = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={MarginTitle} span={MarginSubTitle} />
        <CardBody>
          <div className="gradient-border">
            {PaddingList.map((item, index) => (
              <div key={index} className="helper-common-box gap-0 mb-0">
                <div className={`helper-box m-${item} border bg-light`}></div>
                <span>{`.m-${item}`}</span>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Margin;
